import script from "./LicenseOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./LicenseOverview.vue?vue&type=script&setup=true&lang=js"

import "./LicenseOverview.vue?vue&type=style&index=0&id=7553664d&scoped=true&lang=scss"

import exportComponent from "/home/lexmodo/Vue/FraudLabs/fraudlabs_vue/fraudlabs_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7553664d"]])

export default __exports__